import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { motion } from 'framer-motion'

import AspectRatio from 'components/ui/AspectRatio'
import Image from 'components/ui/Image'

import s from './Cards.module.scss'
const cn = classNames.bind(s)

const _ = {
  hBasis: 900,
}

const variants = {
  hide: {
    x: 0,
    y: 0,
    transition: {
      duration: 0.45,
    },
  },
}

const Card = ({ card, index, total, maxIndex, constraintRef, onCardDragged, show }) => {
  const [zIndex, setZIndex] = useState(total - index)
  const [isDragging, setIsDragging] = useState(false)
  const ratio = card.dimensions.width / card.dimensions.height || 1

  const onStart = () => {
    setIsDragging(true)
    setZIndex(maxIndex)
    onCardDragged(maxIndex + 1)
  }

  const onEnd = () => {
    setIsDragging(false)
  }

  useEffect(() => {
    !show && setZIndex(total - index)
  }, [show])

  return (
    <motion.li
      drag
      className={cn('card', { isDragging })}
      style={{ '--w': (card.dimensions.width || 300) / 2 / _.hBasis, zIndex }}
      dragConstraints={constraintRef}
      onPointerDown={onStart}
      onDragStart={onStart}
      onPointerUp={onEnd}
      onDragEnd={onEnd}
      variants={variants}
      animate={!show && 'hide'}
    >
      <div className={cn('rotor')}>
        <AspectRatio ratio={ratio}>
          <Image src={card} alt={card.alt || ''} />
        </AspectRatio>
      </div>
    </motion.li>
  )
}

Card.propTypes = {
  card: PropTypes.object,
  index: PropTypes.number,
  constraintRef: PropTypes.object,
  total: PropTypes.number,
  show: PropTypes.bool,
  maxIndex: PropTypes.number,
  onCardDragged: PropTypes.func,
}

export default Card
